// Рисунок под курсором: выделенный узел figure или курсор в его подписи.
import type { Node as PMNode } from '@tiptap/pm/model';
import type { Ctx } from '../../../core/registry';
import { ancestor } from '../util';

export function figureAt(ctx: Ctx): { pos: number; node: PMNode } | null {
  const ed = ctx.editor;
  if (!ed) return null;
  const a = ancestor(ed, 'figure');
  return a ? { pos: a.pos, node: a.node } : null;
}
